<template>
	<b-container class="text-left tb-margin">
	  <b-row class="mb-3" align-h="center">
	    <b-col class="top-title" sm="12" md="6">
	    	{{ $t('change-pass') }}
	    </b-col>
	  </b-row>

	  <b-row class="mb-4" align-h="center">
	    <b-col sm="12" md="6">
			<p v-if="onceatime" class="p-2 text-center" style="color:darkred; border:solid 1px darkred;" v-html="$t('pass-anf')"></p> 
	    	<span style="font-weight:300">{{ $t('new-pass') }} </span><br>
			<b-form-input class="mb-4" size="sm" type="password" required v-model="password" :placeholder="$t('new-pass')"></b-form-input>
	    	<span style="font-weight:300">{{ $t('confirm-pass') }}</span><br>
			<b-form-input class="mb-4" size="sm" type="password" required v-model="password2" @keyup.enter="setPassword()" :placeholder="$t('confirm-pass')"></b-form-input>
	    </b-col>
	  </b-row>
	  <b-row class="mb-3 text-center" align-h="center">
	    <b-col sm="12" md="6">
		  <div v-if="!logging" class="gera-btn pt-3 pb-3" @click="setPassword()">
				{{ $t('set-new-pass') }}
			</div>
 		  <div v-else class="text-center">
			<b-spinner variant="primary"></b-spinner>
		  </div>
	    </b-col>
	  </b-row>
<!--
	  <b-row v-if="error" class="mb-3 text-center" align-h="center">
	    <b-col sm="12" md="6">
		  <div class="gera-btn red-btn cursord">Fehler: {{error}}</div>
	    </b-col>
	  </b-row>
	  <b-row v-if="message" class="mb-3 text-center" align-h="center">
	    <b-col sm="12" md="6">
		  <div class="gera-btn green-btn cursord">{{message}}</div>
	    </b-col>
	  </b-row>
-->
	  <b-row class="mb-3 text-center" align-h="center">
	    <b-col sm="12" md="6">
		  <div class="gera-btn cancel-btn" @click="doCancel()">{{  $t('cancel') }}</div>
	    </b-col>
	  </b-row>
		<app-modal width="350px" @closeModal="showMessage=false" v-show="showMessage">
			<div slot="title">
				<div class="float-left" :style="messageColor"><i class="fas fa-exclamation-circle fa-2x" :style="messageColor"></i></div><div class="float-left ml-2 modal-header-text" :style="messageColor">{{modalMessage}}</div>
			</div>
			<div slot="content" class="text-left bb-gera"></div>
			<div slot="buttons-right">
				<b-button class="btn-confirm" size="sm" @click="showMessage=false">OK</b-button>
			</div>
		</app-modal>
	</b-container>
</template>
<script>
import api from '@/components/backend-api';
import appModal from '@/components/Modal.vue';
export default {
  name: "setPassword",
  props: {
	  onceatime: false
  },
  components: {
	appModal
  },
  data () {
    return {
		showMessage: false,
		modalMessage: '',
		messageColor: 'color:#307bad',
    	focused: true,
    	logging: false,
		password: '',
		password2: '',
		error: null,
		message: null
    }
  },
/*
  mounted(){
  	this.focused: true,
  },
*/
  methods: {
  	doCancel () {
      	localStorage.setItem('storedUser', this.user);
		localStorage.setItem('storedPass', this.password);
		this.$store.state.userData.passwordchange = false;  
	    this.$store.dispatch('logout');
//  		this.$emit('wontChange');
  	},
  	setPassword () {
		if (this.password.trim() == '' && this.password2.trim() == '') {
			// ERROR: Passwords Must not be empty!!!
			this.modalMessage = 'Passwort und Passwort bestätigung dürfen nicht leer sein!';
			this.showMessage = true;
			return false;
		}
		if (this.password.trim() == '') {
			// ERROR: Passwords Must not be empty!!!
			this.modalMessage = 'Passwort darf nicht leer sein!';
			this.messageColor = 'color:darkred';
			this.showMessage = true;
			return false;
		}
		if (this.password2.trim() == '') {
			// ERROR: Passwords Must not be empty!!!
			this.modalMessage = 'Passwort bestätigung darf nicht leer sein!';
			this.messageColor = 'color:darkred';
			this.showMessage = true;
			return false;
		}
		if (this.password.trim().length<6) {
			// ERROR: password Must be at least 6 characters long!!!
			this.modalMessage = 'Passwort darf mindestens 6 Zeichen lang sein!';
			this.messageColor = 'color:darkred';
			this.showMessage = true;
			return false;
		}
		if (this.password.trim() !== this.password2.trim()) {
			// ERROR: Passwords are not the same!!!
			this.modalMessage = 'Passwort und Passwort bestätigung sind nicht gleich!';
			this.messageColor = 'color:darkred';
			this.showMessage = true;
			return false;
		}
	  
		this.error = null;
		this.message = null;
		this.logging = true;
		api.executePostServerAction('/auth/changepassword/', { password: this.password }, true )
		// api.forgetPassword({ email: this.email.trim() })
			.then(response => {
				this.logging = false;
				// console.log('Response:');
				// console.log(response);
				if	(response.status == 200) {
					this.messageColor = 'color:#307bad';
					this.modalMessage = 'Sie haben das Passwort erfolgreich geändert!'
				} else {
					this.messageColor = 'color:darkred';
					this.modalMessage = response.data.message;
				}

				this.showMessage = true;

				this.password = '';
				this.password2 = '';

				if (response.status == 200) {
					setTimeout(()=>{
						this.$store.state.userData.passwordchange = false;
					},5000)
				}
			})
			.catch(error => {
				this.logging = false;
				console.log('Save profile error!');
				console.log('Error: ' + error);
				console.log(error.response);
				// this.error = error.response.data.message;
				this.modalMessage = error.response.data.message;
				this.showMessage = true;
			})
	}
  },
  mounted() {
	this.password = '';
	this.password2 = '';
  }
};
</script>
<style>
	.cancel-btn {
		background-color:white !important; border:solid 1px darkred !important; color:darkred; font-size:0.9em !important;
	}
</style>
<i18n>
	{
		"sl": {
			"change-pass": "Spremeni geslo",
			"new-pass": "Novo geslo",
			"confirm-pass": "Potrdi geslo",
			"pass-anf": "Prijavili ste se z enkratnim geslom.<br>Iz varnostnih razlogov morate spremeniti geslo.",
			"set-new-pass": "Nastavi novo geslo",
			"cancel": "Prekliči",

			"pass-forget": "Pozabil sem geslo",
			"email": "Elektronski naslov",
			"email-enter": "Vpišite vaš elektronski naslov",
			"get-new-pass": "Zahtevaj novo geslo",
			"back-to-login": "Nazaj na prijavo"
		},
		"de": {
			"change-pass": "Passwort endern",
			"new-pass": "Neues Passwort",
			"confirm-pass": "Passwort bestätigen",
			"pass-anf": "Sie haben sich mit einem einmaligen Passwort angemeldet.<br>Aus Sicherheitsgründen müssen sie Ihr Passwort ändern.",
			"set-new-pass": "Neues Passwort stellen",
			"cancel": "Abbrechen",

			"pass-forget": "Passwort vergessen ",
			"email": "Email",
			"email-enter": "Email eingeben",
			"get-new-pass": "Neues Passwort anfordern",
			"back-to-login": "Zurück zu Login"
		},
		"en": {
			"change-pass": "Change password",
			"new-pass": "New password",
			"confirm-pass": "Confirm password",
			"pass-anf": "You have registered with a one-time password.<br>For security reasons, you must change your password.",
			"set-new-pass": "Set new password",
			"cancel": "Cancel",

			"pass-forget": "Forgot password",
			"email": "Email",
			"email-enter": "Enter email address",
			"get-new-pass": "Get new password",
			"back-to-login": "Back to login"
		}
	}
</i18n>
